import React from "react"
import { ButtonBase, ButtonProps } from "./ButtonBase"

export const ButtonNeutral = ({ className, ...props }: ButtonProps) => {
  return (
    <ButtonBase
      className={`shadow-buttonNuetral text-textPrimary bg-white hover:bg-whiteHover active:bg-greyBorder disabled:shadow-buttonNuetral disabled:bg-whiteHover ${className}`}
      {...props}
    />
  )
}
